// extracted by mini-css-extract-plugin
export default {"advanced-section":"mTXWmmxUjJ","advancedSection":"mTXWmmxUjJ","small-field":"qQ79mMefvF","smallField":"qQ79mMefvF","warning-tooltip":"oWuV1b6uCA","warningTooltip":"oWuV1b6uCA"};